import React, {Component} from 'react';
import {connect} from 'react-redux';
import {removeProject,projectNewToggle,getSchemaTemplate,setError} from "../../../store/actions";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import ColDef  from "ag-grid-community";
import CheckboxAgGridEditor from "./FieldRenderer/CheckboxAgGridEditor";
import SelectAgGridEditor from "./FieldRenderer/SelectAgGridEditor";
import CustomIconsAgGrid from "./FieldRenderer/CustomIconsAgGrid";
import SelectAgGridRenderer from "./FieldRenderer/SelectAgGridRenderer";
import SimpleInputAgGridRenderer from "./FieldRenderer/SimpleInputAgGridRenderer";
import SimpleInputAgGridEditor from "./FieldRenderer/SimpleInputAgGridEditor";

class ProjectsTable extends Component {
  state = {
    arraySelectedProjectsId: [],
    columnDefs: [],
    rowData: [],
    defaultColDef: {
      editable: true,
      sortable: true,
      resizable: true
    },
    rowSelection: "multiple",
    getNodeChildDetails: function getNodeChildDetails(rowItem) {
      if (rowItem.participants) {
        return {
          group: true,
          expanded: false,
          children: rowItem.participants,
          key: rowItem.pname,

        };
      } else {
        return null;
      }
    },
    frameworkComponents: {
      checkboxAgGridEditor: CheckboxAgGridEditor,
      selectAgGridEditor: SelectAgGridEditor,
      customIcons: (params)=> <CustomIconsAgGrid params={params} />,
      selectAgGridRenderer: SelectAgGridRenderer,
      simpleInputAgGridRenderer: SimpleInputAgGridRenderer,
      simpleInputAgGridEditor: SimpleInputAgGridEditor,
    },
    cellRendererSelector: ColDef,
    cellEditorSelector: ColDef,
  };

  render() {
    const {rowDef,projectTableHeaders,setError} = this.props;
    const {defaultColDef,rowSelection,getNodeChildDetails,frameworkComponents} = this.state;
    console.log(projectTableHeaders);
    return (
      <div style={{overflowX: 'scroll',height: '100%'}}>
        <AgGridReact
          columnDefs={projectTableHeaders}
          groupSelectsChildren={true}
          enableRangeSelection={true}
          animateRows={true}
          rowData={rowDef}
          setError={setError}
          enableGroupEdit={true}
          singleClickEdit={true}
          defaultColDef={defaultColDef}
          rowSelection={rowSelection}
          getNodeChildDetails={getNodeChildDetails}
          frameworkComponents={frameworkComponents}
        />
      </div>
    )
  }
}


export default connect(null, {removeProject,projectNewToggle,getSchemaTemplate,setError})(ProjectsTable);


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/ProjectsTable.js